module.exports = __webpack_public_path__ + "assets/img/swiper-4.db9f1ad3.jpg";